module.exports = __webpack_public_path__ + "static/media/home-icon-active.3adf1d7c.svg";